<template>
  <span class="dot" :style="{ backgroundColor: color }"></span>
</template>

<script>
import { defineComponent } from 'vue';

const comp = defineComponent({
  name: 'Dot',
  props: {
    color: { type: String, required: true },
  },
});
export default comp;
</script>

<style lang="postcss" scoped>
.dot {
  display: inline-block;
  width: var(--space-10);
  height: var(--space-10);
  border-radius: 50%;
  margin-right: var(--space-6);
}
</style>
